// extracted by mini-css-extract-plugin
export default {"fondoLogin":"RestorePasswordComponent_fondoLogin__2mONu"};